import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Model } from '@df/catalog/model';
import { CategoryComponent } from '../category/category.component';
import { PageComponent } from '../page/page.component';
import { ProductComponent } from '../product/product.component';

@Component({
    selector: 'model',
    templateUrl: './model.component.html',
    standalone: true,
    imports: [CategoryComponent, PageComponent, ProductComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModelComponent {
    @Input({ required: true })
    model!: Model;
}
